import { GetEditionParams } from './getEditionParams';
import { GetMagazineParams } from './getMagazineParams';
import { GetArticleParams } from './GetArticleParams';
import { FileParam } from "./FileParam";

export {
    GetMagazineParams,
    GetEditionParams,
    GetArticleParams,
    FileParam
}


// WEBPACK FOOTER //
// ./src/APIModels/ApiParamsIndex.js